import { goToUrl } from "apps/visits/core/utils/go-to-url";
import type { AxiosError } from "axios";
import { t } from "i18next";
import type { CreateOrderErrorResponse } from "../api/group-actions-ordering.types";
import { routes } from "../config/routes";

export const useHandleCreateOrderErrors = (error: AxiosError<CreateOrderErrorResponse> | null): string | undefined => {
  if (!error) return undefined;

  const err = error?.response?.data?.error;
  const patientsLimitReachedError = err?.base?.filter((errorObj) => errorObj.error === "patients_limit_reached");
  const alreadyRegisteredError = err?.base?.filter((baseErr) => baseErr.error === "patient_already_registered");
  const bloodTestPackageLimitReachedError = err?.base?.filter(
    (baseErr) => baseErr.error === "blood_test_package_limit_reached",
  );

  if (patientsLimitReachedError && patientsLimitReachedError.length > 0) {
    goToUrl(routes.limitReached.raw());
    return undefined;
  }

  if (bloodTestPackageLimitReachedError && bloodTestPackageLimitReachedError.length > 0) {
    return t("GROUP_ACTIONS_ORDERING.ERRORS.BLOOD_TEST_PACKAGE_LIMIT_REACHED");
  }

  if (alreadyRegisteredError && alreadyRegisteredError.length > 0)
    return t("GROUP_ACTIONS_ORDERING.ERRORS.PATIENT_ALREADY_REGISTERED");

  return t("COMMONS.ERRORS.GENERAL_API_ERROR");
};
